import React, {Fragment, useEffect, useRef, useState} from 'react';
import PropTypes from "prop-types";
import ModalContentWrapper from '../ModalContentWrapper';
import '../TwoColumnModal.scss';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import {getUserRights, updateUserRights} from "root/DataFunctions/RightsDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useForm} from "react-hook-form";
import {useFieldArray} from "react-hook-form";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";

const ModalManageRights = (props) =>
{
    //State management
    const [buttonState, setButtonState] = useState('');
    const [data, setData] = useState({isLoading: true, data: []});

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                rights: [
                ]
            }
        });

    const { fields, append } = useFieldArray({
        control,
        name: "rights"
    });

    useEffect(() =>
    {
        getUserRights(props.user_id, null, (response) =>
        {
            const rights = getDataFromResponse(response);

            const formFieldData = rights.map((item) =>
            {
                return {
                    description: item.long_description,
                    assigned: item.onOff,
                    rights_id: item.rights_id
                }
            })

            setValue ( 'rights', formFieldData ) ;
            setData({isLoading: false, data: rights});
        });
    }, []);

    const onSaveComplete = () =>
    {
        props.onSaveCompleted('saved');
        props.onClose();
    }

    const onClickCancel = () =>
    {
        props.onClose();
    }

    const doSave = (data, onSaveComplete) =>
    {
        updateUserRights(props.user_id, data, onSaveComplete);
    }

    const disableButtons = () =>
    {
        setButtonState('disabled');
    }

    const onSubmit = (data) =>
    {
        disableButtons();
        doSave(data, onSaveComplete);
    }

    const onClickSaveButton = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const submitButton = (onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className="btn btn-icon btn-primary btn-icon-right btn-small">Save<i className="et-save" /></button>
        )
    }

    const formContent = () =>
    {
        if (data.isLoading === true)
        {
            return (
                <div style={{width: props.width}}>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
        {
            return (
                <Fragment>
                        <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                            {fields.map((item, index) => (
                                <div key={item.id} className='slider-group-long-text' >
                                    <label>{item.description}</label>
                                    <FormToggle readOnly={false} control={control} name={`rights.${index}.assigned`}/>
                                </div>
                            ))}

                        </form>

                    <div className="d-flex flex-row justify-content-end">
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left"/></button>
                        {submitButton(onClickSaveButton)}
                    </div>
                </Fragment>
            )
        }
    }

    const title = () =>
    {
        const headerStyle = {marginBottom: '10px'};
        return <h3 style={headerStyle}>{'Manage rights for ' + props.name}</h3>
    }

    return (
        <ModalContentWrapper className="modal-wrapper" width={'600px'} columns={2}>
            {title()}
            {formContent()}
        </ModalContentWrapper>
    )
}

export default ModalManageRights;

ModalManageRights.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};